import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import './css/brand.scss'

Vue.config.productionTip = false

Vue.prototype.$api = {
  async assets (uri, data, config) {
    return (
      await axios.post(`https://asset-generator.exatom.io${uri}`, data, { ...await this._config(), ...config })
    )
  },
  async _config () {
    return {
      headers: {
        Accept: 'application/x.olympus-api.v1.1+json'
      }
    }
  },

  tagsAdded: [],
  addTags (tags = []) {
    // Exatom
    if (!this.tagsAdded.includes('exatomEvent') && (!tags.length || tags.includes('exatomEvent'))) {
      try {
        const exatomEvent = document.createElement('script')
        const s = document.getElementsByTagName('script')[0]
        exatomEvent.src = 'https://assets.exatom.io/event.js?clientCode=D095'
        s.parentNode.insertBefore(exatomEvent, s)
      } catch (e) {}
      this.tagsAdded.push('exatomEvent')
    }

    // Exatom conversion tag
    if (!this.tagsAdded.includes('exatomConversion') && tags.includes('exatomConversion')) {
      try {
        const exatomConversion = document.createElement('script')
        const s = document.getElementsByTagName('script')[0]
        exatomConversion.src = 'https://assets.exatom.io/conversion.js?clientCode=D095&tagCode=M6WPL'
        s.parentNode.insertBefore(exatomConversion, s)
      } catch (e) {}
      this.tagsAdded.push('exatomConversion')
    }
  }
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#scoreApp')
